export default __webpack_public_path__ + "images/873a373d452d4d351bb75c9d84afb3a7.png";